import React, { useState, useRef, useEffect } from "react";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "@vtaits/react-color-picker/dist/index.css";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";
import {
    Container,
    Button,
    Col,
    Row,
    Label,
    Card,
    CardBody,
    Input
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
    getData as onGetDataTable,
    clearData as onClearDataTable,
    deleteAccountTransactionClient as onDeleteAccountTransactionClient,
} from "../../../store/actions";
import { useSelector, useDispatch } from "react-redux";
import CurrencyFormat from 'react-currency-format';
import Filter from "./filter";
import DataTable from "components/Common/DataTable";
import DeleteModal from "components/Common/ModalDeleteCustom";

const Transaction = () => {
    //meta title
    document.title = "Transaction | Client Transaction | Des Counts";
    const dispatch = useDispatch();
    
    const urlData = "account-transaction-client/get"
    const [isOpenDelete, setIsOpenDelete] = useState(false)
    const [deleteData, setDeleteData] = useState(null)
    const [messageDelete, setMessageDelete] = useState(null)
    const [triggerRefresh, setTriggerRefresh] = useState(false)

    const { page, pageSize } = useSelector(state => ({
        page: state.DataTable.page,
        pageSize: state.DataTable.length,
    }));

    var filterWaitingApproval = useRef(null)
    var currentFilter = null;

    const getCurrentFilter = () => {
        return currentFilter;
    }

    const onOpenDeleteCommand = (data) => {
        setDeleteData(data)
        setMessageDelete("Transaction with remarks \"" + data?.remarks + "\" will be delete.")
        setIsOpenDelete(true)
    }

    const onDeleteCommand = () => {
        setIsOpenDelete(false)
        dispatch(onDeleteAccountTransactionClient({ id: deleteData.id, companyId: deleteData.companyId, accountNumberId: deleteData.accountNumberId }, () => {
            setTriggerRefresh(!triggerRefresh)
        }))
    }

    const columnData = [
        {
            key: "dateStr",
            name: "Date",
            headerClass: "text-center",
            contentClass: "text-center align-middle",
        },
        {
            key: "accountNumber.name",
            name: "Account Number",
            headerClass: "text-center",
            contentClass: "text-center align-middle",
            render: (row) => {
                return row?.accountNumber?.name ?? "";
            }
        },
        {
            key: "account.name",
            name: "Account",
            headerClass: "text-center",
            contentClass: "text-center align-middle",
            render: (row) => {
                return row?.account?.name ?? "-";
            }
        },
        {
            key: "remarks",
            name: "Remarks",
            headerClass: "text-start",
            contentClass: "text-start align-middle",
            render: (row) => {
                return row?.remarks ?? "";
            }
        },
        {
            key: "type",
            name: "Type",
            headerClass: "text-center",
            contentClass: "text-center align-middle",
            render: (row) => {
                return (row?.type ?? "-").toUpperCase();
            }
        },
        {
            key: "nominal",
            name: "Nominal",
            headerClass: "text-center",
            contentClass: "text-end align-middle",
            render: (row) => {
                return <CurrencyFormat value={row.nominal ?? 0} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0}
                    displayType={'text'} />;
            }
        },
        {
            key: "status",
            name: "Status",
            headerClass: "text-center",
            contentClass: "text-center align-middle",
            render: (row) => {
                if (row.approved === true) {

                    return <span className={"badge bg-success"}>Approved</span>;
                }
                else if (row.approved === false) {
                    return <span className={"badge bg-danger"}>Rejected</span>;
                }
                else {
                    return <span className={"badge bg-info"}>Waiting Approval</span>;
                }

            }
        },
        {
            key: "action",
            name: "Action",
            headerClass: "text-center",
            contentClass: "text-center align-middle",
            render: (row) => {
                if (row.approved === true) {
                }
                else if (row.approved === false) {
                }
                else {
                    return <Button color="danger" onClick={() => {
                        onOpenDeleteCommand(row)
                    }}>
                        <i className="fa fa-trash"></i>
                    </Button>;
                }

            }
        }
    ]

    const onRefreshCommand = (filter) => {
        let param = { ...filter, isWaitingApproval: filterWaitingApproval.current.checked ? true : null }
        currentFilter = param;
        console.log(param);
        console.log(currentFilter);
        dispatch(onGetDataTable(urlData, page, pageSize, param))
    }

    useEffect(() => {
        dispatch(onClearDataTable())
    }, [dispatch])

    return (
        <React.Fragment>
            <DeleteModal show={isOpenDelete} onDeleteClick={onDeleteCommand} message={messageDelete} onCloseClick={() => setIsOpenDelete(false)} />
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Client Transaction" breadcrumbItem="Transaction" />
                    <Row className="mb-3">
                        <Col xs="12">
                            <Filter onSubmit={onRefreshCommand} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className="flex-grow-1">
                                            <div className="form-check ms-2 mt-2">
                                                <Input
                                                    type="checkbox"
                                                    className="form-check-Input"
                                                    defaultChecked={true}
                                                    id={"filterWaitingApproval"}
                                                    innerRef={filterWaitingApproval}
                                                />
                                                <Label
                                                    className="form-check-label ms-1"
                                                    htmlFor={"filterWaitingApproval"}>
                                                    Only Show Waiting For Approval
                                                </Label>
                                            </div>
                                        </div>
                                        <Link to="/client-transaction/transaction/add-by-account-number">
                                            <Button color="primary" className="btn btn-primary waves-effect waves-light me-2">
                                                Add By Account Number (Bank)
                                            </Button>
                                        </Link>
                                        <Link to="/client-transaction/transaction/add">
                                            <Button color="secondary" className="btn btn-secondary waves-effect waves-light me-2">
                                                Add Transaction
                                            </Button>
                                        </Link>
                                        <Link to="/client-transaction/create-by-excel">
                                            <Button color="success" className="btn btn-success waves-effect waves-light">
                                                Add By Excel
                                            </Button>
                                        </Link>
                                    </div>
                                    <DataTable columns={columnData} url={urlData} trigger={triggerRefresh} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

Transaction.propTypes = {
    className: PropTypes.string,
};

export default Transaction
